import * as React from "react";
import injectSheet from "react-jss";
import { TweenMax, Back } from "gsap";
import * as PropTypes from "prop-types";
import { type } from "os";

const styleSheet = {
  iconButton: {
    width: "161px",
    height: "49px",
    fontWeight: "500",
    objectFit: "contain",
    fontFamily: "CircularStd",
    color: "#4f5b84",
    fontSize: "14px",
    cursor: "pointer",
    display: "inline-flex",
    textTransform: "none",
    borderRadius: "6px",
    boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.2)",
    backgroundImage: "linear-gradient(to top, #fbfdff, #ffffff)"
  },
  //   iconDisplay: {
  container: {
    fontFamily: "CircularStd",
    display: "flex",
    width: "100%",
    justifyContent: "space-around",
    fontStyle: "normal",
    fontStretch: "normal",
    lineHeight: "normal",
    letterSpacing: "normal"
  },
  icon: {
    width: "24px",
    height: "25px"
  },
  text: {
    display: "flex",
    flexDirection: "column",
    alignSelf: "center"
  }
  // }
};

const ButtonElement = React.createRef<HTMLButtonElement>();

const hoverState = (event: React.MouseEvent<HTMLButtonElement>) => {
  event.stopPropagation();
  event.preventDefault();
  TweenMax.to(event.currentTarget, 0.35, {
    boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2)",
    backgroundColor: "#f4f4f4"
  });
};

const hoverOffState = (event: React.MouseEvent<HTMLButtonElement>) => {
  event.stopPropagation();
  event.preventDefault();
  TweenMax.to(event.currentTarget, 0.35, {
    boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.2)",
    backgroundImage: "linear-gradient(to top, #fbfdff, #ffffff)"
  });
};

interface ButtonProps {
  onClick?: () => void;
  classes: {
    iconButton: string;
    icon: string;
    container: string;
    text: string;
  };
  disabled: boolean;
  type?: "button" | "submit" | "reset" | undefined;
}

interface GoogleDisplayProps {
  // classes: {
  containerStyle: string;
  iconStyle: string;
  textStyle: string;
  // }
}

const GoogleDisplay: React.FC<GoogleDisplayProps> = props => (
  <div className={props.containerStyle}>
    <div>
      <img
        className={props.iconStyle}
        src="https://img.icons8.com/color/48/000000/google-logo.png"
      />
    </div>
    <div className={props.textStyle}>{"Google"}</div>
    <div />
  </div>
);

const Button: React.FC<ButtonProps> = props => {
  return (
    <button
      ref={ButtonElement}
      type={props.type}
      className={props.classes.iconButton}
      onClick={props.onClick}
      onMouseEnter={hoverState}
      onMouseLeave={hoverOffState}
      disabled={props.disabled}
    >
      {/* {props.children} */}
      <GoogleDisplay
        iconStyle={props.classes.icon}
        containerStyle={props.classes.container}
        textStyle={props.classes.text}
      />
    </button>
  );
};

Button.propTypes = {
  onClick: PropTypes.func,
  disabled: PropTypes.bool.isRequired
};

Button.defaultProps = {
  onClick: Function
};

export default injectSheet(styleSheet)(Button);
